import { IOrg } from '../../../types/org'
import '../org-info.scss'
import ToolTip from '../../common/tooltip/tooltip';
import { Label } from 'reactstrap';

type ParentInformationProps = {
    org: IOrg;
}

const ParentInformation = (props: ParentInformationProps) => {
    const {org} = props
    
    return (
        <div className="parent-information">
            {org.parentOrg && <>
                
                <ToolTip id={`${org.id}_parent_tooltip`} orgId={org.parentOrg.id}>
                    <span style={{pointerEvents: "none"}}>Name: {org.parentOrg.orgName}
                    </span>                                    
                </ToolTip>
                <div role="region" aria-label="Start Date">
                    Start Date: {org.parentOrg.startDate}
                </div>
            </>}
        </div>
  )
}

export default ParentInformation